import { useState } from 'react';

interface Props {
    name: string;
    label: string;
    value: string | null;
    onChange: (name: string, value: string | boolean | number[] | number | undefined) => void;
    required: boolean;
    isDisabled?: boolean;
}

export default function DateField({
    name,
    label,
    value,
    required,
    onChange,
    isDisabled = false,
}: Props) {
    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.classList.add('touched');
    };

    if (value && value.includes('T')) value = value.split('T')[0];

    return (
        <div className='mb-3'>
            <label htmlFor={name} key={`label-${name}`} className='form-label'>
                {label}
            </label>
            <input
                type='date'
                className='form-control'
                id={name}
                key={name}
                name={name}
                value={value !== null ? value : undefined}
                required={required}
                onChange={(e) => onChange(name, e.target.value)}
                onFocus={onFocus}
                disabled={isDisabled}
            />
        </div>
    );
}
